import store from '../../store'
import {archiveMeetingProjectConnectionRequest} from '../../actions/meetings'


export function archiveMeetingProjectConnection(connectionId) {	
	return store.dispatch(archiveMeetingProjectConnectionRequest(connectionId))
}

